export const DEFAULT_VIEW = 'default';
export const HOLES_VIEW = 'holes-view';
export const QUALIFY_RESERVE_FLAG = 'qualifyReserveFlag';
export const TEE_START_POSITION = 'teeStartPosition';
export const CLUB_NAME = 'clubName';
export const FQ_HOLE = 'fqHole';
export const RQ_HOLE = 'rqHole';
export const R1 = 'r1';
export const R2 = 'r2';
export const ROUND_ONE = '1';
export const ROUND_TWO = '2';
export const TOTAL = 'total';
export const IN = 'in';
export const SCORE = 'score';
export const TODAY = 'today';
export const QUALIFIED_STATUS = 'qualifiedStatus';
export const TENTH_HOLE = 10;
